export default {
    MP: 'Menor Preço',
    MD: 'Maior Desconto'
}